import DepositoShow from './DepositoShow.vue'
export default DepositoShow
